$(window).on('load', function(){
  $('.slidearea').slick({
    autoplay: true,
    dots: true,
    arrows: false,
    slidesToShow: 1,
    slidesToScroll: 1,
    appendDots: $('.slidearea_dots'),
    centerMode: true,
    // centerPadding: '20px',
    centerPadding: '0',
    responsive: [
      {
        breakpoint: 901, // 399px以下のサイズに適用
        settings: {
          centerMode: false,
        },
      },
    ],
  });
});
$(window).resize(function(){
  $('.slidearea')[0].slick.refresh();
});